var m = require('mithril');

var Model = require('../libs/Model');
var layout = require('../layout/layout');
var modalForm = require('../layout/components/modalForm');
var loaders = require('../layout/components/loaders');
var auth = require('../auth/models/session');
var edit = require('../layout/components/edit');
var networkOverviewPage = require('../network/components/networkOverviewPage');
var hostPage = require('../network/components/hostPage');
var devicePage = require('./bacnetDevicePage');
var resourcePage = require('../network/components/resourcePage');
var bacnetObjectPage = require('./bacnetObjectPage');
var calendarEditor = require('./calendarEditor');
var scheduleEditor = require('./scheduleEditor');

var bacnetServerModel = require('./models/bacnetServer');
var bacnetDeviceModel = Object.assign(require('../../../../models/bacnet/bacnetDevice'), Model);
var bacnetObjectModel = Object.assign(require('../../../../models/bacnet/bacnetObject'), Model);
var bacnetPropertyModel = Object.assign(require('../../../../models/bacnet/bacnetProperty'), Model);
var discoveryLogModal = require('./discoveryLogModal');
var serverDiscoveryModal = require('./serverDiscoveryModal');
var scDiscoveryModal = require('./scDiscoveryModal');

bacnetServerModel.actions = [
  {
    name: 'Discover Devices',
    visible: function () {
      return edit.vm.editing() && auth.user().isSuperuser == 1;
    },
    func: function (ctrl) {
      if (ctrl.record.transport === 'bacnet-sc') {
        return scDiscoveryModal.open(ctrl.init, ctrl.record.scConnection);
      }
      return serverDiscoveryModal.open(ctrl.record, ctrl.init);
    }
  }
];

bacnetDeviceModel.actions = [
  {
    name: 'Discover Objects',
    func: function (ctrl) {
      discoveryLogModal.open(ctrl.record, function () { ctrl.init(); });
    }
  }
];

bacnetObjectModel.actions = [
  {
    name: 'Discover Properties',
    func: function (ctrl) {
      return loaders.requestWithLoader({
        url: ctrl.record['@id'] + '/sync/',
        method: "GET",
        loader: 'submit'
      })
      .then(function (res) {
        return ctrl.init();
      })
      .catch(function (e) {
        alert(e);
      })
    }
  }
];

var bacnetServer = modalForm(bacnetServerModel);
var bacnetDevice = modalForm(bacnetDeviceModel);
var bacnetObject =  modalForm(bacnetObjectModel);
var bacnetProperty =  modalForm(bacnetPropertyModel);

var routes = {
  '/bacnet': {
    view: function() {
      return m(layout, m(networkOverviewPage,{form:bacnetServer,activeTab:'Networks'}));
    }
  },
  '/bacnetserver': {
    view: function() {
      return m(layout, m(networkOverviewPage,{form:bacnetServer,activeTab:'Networks'}));
    }
  },
  '/bacnetserver/:id': {
    view: function() {
      return m(layout, m(hostPage,{recordModel:bacnetServer,form:bacnetDevice,activeTab:'Networks'}));
    }
  }, 
  '/bacnetdevice/:id': {
    view: function() {
      return m(layout, m(devicePage,{recordModel:bacnetDevice,form:bacnetObject}));
    }
  },
  '/bacnetobject/:id': {
    view: function() {
      return m(layout, m(bacnetObjectPage,{recordModel:bacnetObject,form:bacnetProperty}));
    }
  },
  '/bacnetproperty/:id': {
    view: function() {
      return m(layout, m(resourcePage,{recordModel:bacnetProperty,activeTab:'Networks'}));
    }
  },
  '/bacnetcalendar/:id': {
    view: function() {
      return m(layout, m(calendarEditor));
    }
  },
  '/bacnetschedule/:id': {
    view: function() {
      return m(layout, m(scheduleEditor));
    }
  }
};

module.exports = routes;
